import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 525,
	height: 427,
	viewBox: "0 0 525 427",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M86.31 55.0406H4.33997C1.94305 55.0406 0 56.9837 0 59.3807V421.741C0 424.138 1.94305 426.081 4.33997 426.081H86.31C88.7069 426.081 90.65 424.138 90.65 421.741V59.3807C90.65 56.9837 88.7069 55.0406 86.31 55.0406Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M520.43 426.081H339.69C337.64 426.081 335.97 424.411 335.97 422.361V3.7207C335.97 1.2307 338.37 -0.559296 340.76 0.160704L521.5 54.2507C523.07 54.7207 524.15 56.1707 524.15 57.8107V422.361C524.15 424.411 522.48 426.081 520.43 426.081Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M136.07 426.081H290.55C292.6 426.081 294.27 424.411 294.27 422.361V3.82072C294.27 1.30072 291.81 -0.489291 289.41 0.280709L134.93 53.9507C133.39 54.4407 132.35 55.8807 132.35 57.4907V422.361C132.35 424.411 134.02 426.081 136.07 426.081Z" })
	]
});
export { SvgLogoIcon as ReactComponent };
